<template>
  <div v-if="total > 0" class="pagination-container">
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :page-sizes.sync="pageSizes"
      :layout="layout"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"/>
  </div>
</template>

<script>
export default {
  name: 'EXPagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    // 第几页
    page: {
      type: Number,
      default: 1
    },
    // 共多少页
    limit: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 15, 20, 25, 30, 35, 40]
      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('pagination', { page: this.currentPage, limit: val })
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
    }
  },
  mounted() {
    if(document.getElementsByClassName("el-pagination__jump")[0]){
       document.getElementsByClassName("el-pagination__jump")[0].childNodes[0].nodeValue = "前往";
    }
  },
}
</script>
<style lang="scss" scoped>
.pagination-container{
  background-color: #fff;
  border: none;
  padding-right: 0;
  margin-top: -0.1rem;
  border-radius: 8px;
  padding: 0rem 0.2rem 0.1rem
}
</style>


// WEBPACK FOOTER //
// src/components/EXPagination/index.vue